import { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import FooterMini from '../components/FooterMini';
import { Button } from '../components/ui/button';
import { api } from '../lib/api';

export function Forgot() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api('/api/auth/forgot', { method: 'POST', body: JSON.stringify({ email }) }); }
    finally { setBusy(false); setDone(true); }
  };
  return (
    <Wrap title="Esqueci minha senha">
      {done ? (
        <p className="text-sm text-zinc-700">
          Se houver uma conta com esse e-mail, enviamos um link de redefinição.
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-3">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                 placeholder="E-mail"
                 className="w-full px-3 py-2 rounded-md border border-zinc-200 outline-none focus:border-cyan-500 font-mono text-sm" />
          <Button disabled={busy} type="submit"
                  className="w-full bg-zinc-950 hover:bg-zinc-800 text-cyan-300 font-chunky uppercase tracking-wider">
            {busy ? '...' : 'Enviar link'}
          </Button>
          <div className="text-[12px] text-zinc-500 text-center">
            <Link to="/login" className="hover:text-cyan-700">Voltar para login</Link>
          </div>
        </form>
      )}
    </Wrap>
  );
}

export function Reset() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      await api('/api/auth/reset', { method: 'POST',
        body: JSON.stringify({ token: params.get('token'), password }) });
      nav('/login?reset=1', { replace: true });
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };
  return (
    <Wrap title="Redefinir senha">
      <form onSubmit={submit} className="space-y-3">
        <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)}
               placeholder="Nova senha"
               className="w-full px-3 py-2 rounded-md border border-zinc-200 outline-none focus:border-cyan-500 font-mono text-sm" />
        {err && <div className="text-rose-700 bg-rose-50 border border-rose-200 rounded p-2 text-xs">{err}</div>}
        <Button disabled={busy} type="submit"
                className="w-full bg-zinc-950 hover:bg-zinc-800 text-cyan-300 font-chunky uppercase tracking-wider">
          {busy ? '...' : 'Redefinir'}
        </Button>
      </form>
    </Wrap>
  );
}

export function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState('idle');
  const run = async () => {
    setState('running');
    try {
      await api('/api/auth/verify-email', { method: 'POST',
        body: JSON.stringify({ token: params.get('token') }) });
      setState('ok');
    } catch (_) { setState('fail'); }
  };
  return (
    <Wrap title="Confirmar e-mail">
      {state === 'idle' && (
        <Button onClick={run} className="w-full bg-zinc-950 hover:bg-zinc-800 text-cyan-300 font-chunky uppercase tracking-wider">
          Confirmar
        </Button>
      )}
      {state === 'running' && <p className="text-sm">Confirmando...</p>}
      {state === 'ok' && <p className="text-sm text-emerald-700">E-mail confirmado! <Link to="/account" className="text-cyan-700 underline">Ir para minha conta</Link></p>}
      {state === 'fail' && <p className="text-sm text-rose-700">Token inválido ou expirado.</p>}
    </Wrap>
  );
}

function Wrap({ title, children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 grid place-items-center px-5 py-10 blueprint-grid">
        <div className="w-full max-w-md bg-white rounded-xl border border-zinc-200 shadow-sm p-7">
          <h1 className="font-chunky text-2xl text-zinc-950 mb-4">{title}</h1>
          {children}
        </div>
      </main>
      <FooterMini />
    </div>
  );
}
